"use strict";

function _typeof(obj) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (obj) { return typeof obj; } : function (obj) { return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }, _typeof(obj); }

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireWildcard(require("react"));

var _reactKonva = require("react-konva");

var _useImage3 = _interopRequireDefault(require("use-image"));

require("./rectangle.styles.scss");

var _warning = _interopRequireDefault(require("./warning.png"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _getRequireWildcardCache(nodeInterop) { if (typeof WeakMap !== "function") return null; var cacheBabelInterop = new WeakMap(); var cacheNodeInterop = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(nodeInterop) { return nodeInterop ? cacheNodeInterop : cacheBabelInterop; })(nodeInterop); }

function _interopRequireWildcard(obj, nodeInterop) { if (!nodeInterop && obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { default: obj }; } var cache = _getRequireWildcardCache(nodeInterop); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj.default = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function _slicedToArray(arr, i) { return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest(); }

function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }

function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }

function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }

function _iterableToArrayLimit(arr, i) { var _i = arr == null ? null : typeof Symbol !== "undefined" && arr[Symbol.iterator] || arr["@@iterator"]; if (_i == null) return; var _arr = []; var _n = true; var _d = false; var _s, _e; try { for (_i = _i.call(arr); !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"] != null) _i["return"](); } finally { if (_d) throw _e; } } return _arr; }

function _arrayWithHoles(arr) { if (Array.isArray(arr)) return arr; }

var Rectangle = function Rectangle(_ref) {
  var rectRef = _ref.rectRef,
      rectProps = _ref.rectProps,
      isSelected = _ref.isSelected,
      warningInfo = _ref.warningInfo,
      initWarning = _ref.initWarning,
      moveAllLinesMode = _ref.moveAllLinesMode,
      vLines = _ref.vLines,
      hLines = _ref.hLines,
      rectClick = _ref.rectClick,
      updateVLines = _ref.updateVLines,
      updateHLines = _ref.updateHLines,
      onChangeRect = _ref.onChangeRect,
      onChangeRectEnd = _ref.onChangeRectEnd,
      onChangeTransformEnd = _ref.onChangeTransformEnd,
      tooltipClickAction = _ref.tooltipClickAction,
      onSelectObject = _ref.onSelectObject,
      isSideNavBarInfoOpen = _ref.isSideNavBarInfoOpen;

  var _useImage = (0, _useImage3.default)(_warning.default),
      _useImage2 = _slicedToArray(_useImage, 1),
      image = _useImage2[0];

  var _useState = (0, _react.useState)(false),
      _useState2 = _slicedToArray(_useState, 2),
      showWarningColour = _useState2[0],
      setShowWarningColour = _useState2[1];

  var _useState3 = (0, _react.useState)(false),
      _useState4 = _slicedToArray(_useState3, 2),
      showWarningMessage = _useState4[0],
      setShowWarningMessage = _useState4[1];

  var _useState5 = (0, _react.useState)(null),
      _useState6 = _slicedToArray(_useState5, 2),
      warningMessage = _useState6[0],
      setWarningMessage = _useState6[1];

  var _useState7 = (0, _react.useState)(false),
      _useState8 = _slicedToArray(_useState7, 2),
      showWarningIcon = _useState8[0],
      setShowWarningIcon = _useState8[1];
  /**
   * Updates the Grid locations when rectangle moves.
   * @param {event} e
   */


  var updateRectProps = function updateRectProps(e) {
    onChangeRect(_objectSpread(_objectSpread({}, rectProps), {}, {
      x: e.target.x(),
      y: e.target.y()
    }));
  };
  /**
   * If the lines should not move on moving rectangle (i.e not change x or y values)
   *  then the distance for each line must be recalculated
   * @param {event} e
   */


  var updateStationaryLines = function updateStationaryLines(e) {
    var newVLines = vLines.slice();
    newVLines.forEach(function (line, i) {
      newVLines[i] = _objectSpread(_objectSpread({}, line), {}, {
        xRectDist: newVLines[i].x - e.target.x()
      });
    });
    updateVLines(newVLines);
    var newHLines = hLines.slice();
    newHLines.forEach(function (line, i) {
      newHLines[i] = _objectSpread(_objectSpread({}, line), {}, {
        yRectDist: newHLines[i].y - e.target.y()
      });
    });
    updateHLines(newHLines);
  };
  /**
   * If the lines should move on moving rectangle (i.e. not change xRectDist and yRectDist)
   *  then the x and y values must be recalculated
   * @param {event} e
   */


  var updateMovingLines = function updateMovingLines(e) {
    var newVLines = vLines.slice();
    newVLines.forEach(function (line, i) {
      newVLines[i] = _objectSpread(_objectSpread({}, line), {}, {
        x: newVLines[i].xRectDist + e.target.x()
      });
    });
    updateVLines(newVLines);
    var newHLines = hLines.slice();
    newHLines.forEach(function (line, i) {
      newHLines[i] = _objectSpread(_objectSpread({}, line), {}, {
        y: newHLines[i].yRectDist + e.target.y()
      });
    });
    updateHLines(newHLines);
  };
  /**
   * Updates the distance of the line to the rectangle edges
   */


  var updateLineDistance = function updateLineDistance(e) {
    var newVLines = vLines.slice();
    newVLines.forEach(function (line, i) {
      newVLines[i] = _objectSpread(_objectSpread({}, line), {}, {
        xRectDist: newVLines[i].x - e.target.x()
      });
    });
    updateVLines(newVLines);
    var newHLines = hLines.slice();
    newHLines.forEach(function (line, i) {
      newHLines[i] = _objectSpread(_objectSpread({}, line), {}, {
        yRectDist: newHLines[i].y - e.target.y()
      });
    });
    updateHLines(newHLines);
  };

  var tooltipClick = function tooltipClick() {
    rectClick(rectProps.id);
    var gridInfo = {
      rectRef: rectRef,
      rectProps: rectProps,
      rectClick: rectClick,
      isSelected: isSelected,
      warningInfo: warningInfo,
      initWarning: initWarning,
      warningMessage: warningMessage
    };
    onSelectObject({
      objectType: "rect",
      objectId: rectProps.id
    });
    tooltipClickAction(gridInfo);
  };

  var onRectClick = function onRectClick() {
    rectClick(rectProps.id);
    var gridInfo = {
      rectRef: rectRef,
      rectProps: rectProps,
      rectClick: rectClick,
      isSelected: isSelected,
      warningInfo: warningInfo,
      initWarning: initWarning,
      warningMessage: warningMessage
    };
    tooltipClickAction(gridInfo);
  };
  /**
   * Transformer is changing scale of the node
   * and NOT its width or height
   * but in the store we have only width and height
   * to match the data better we will reset scale on transform end
   */


  var unScaleRectangle = function unScaleRectangle() {
    var node = rectRef.current;
    var scaleX = node.scaleX();
    var scaleY = node.scaleY(); // we will reset it back

    node.scaleX(1);
    node.scaleY(1);
    onChangeRect(_objectSpread(_objectSpread({}, rectProps), {}, {
      x: node.x(),
      y: node.y(),
      // set minimal value
      width: Math.max(5, node.width() * scaleX),
      height: Math.max(node.height() * scaleY)
    }));
  };

  (0, _react.useEffect)(function () {
    if (typeof warningInfo !== "undefined" && initWarning !== null) {
      setShowWarningColour(warningInfo["colourWarning"] || initWarning["colourWarning"]);
      setWarningMessage("".concat(warningInfo["message"], "\n").concat(initWarning["message"].map(function (el) {
        return "".concat(el, "\n");
      }).join("")));
      setShowWarningIcon(true);
    } else if (typeof warningInfo !== "undefined" && initWarning == null) {
      setShowWarningColour(warningInfo["colourWarning"]);
      setWarningMessage(warningInfo["message"]);
      setShowWarningIcon(true);
    } else if (typeof warningInfo === "undefined" && initWarning !== null) {
      setShowWarningColour(initWarning["colourWarning"]);
      setWarningMessage(initWarning["message"].map(function (el) {
        return "".concat(el, "\n");
      }).join(""));
      setShowWarningIcon(true);
    } else if (typeof warningInfo === "undefined" && initWarning === null) {
      setShowWarningColour(false);
      setWarningMessage(null);
      setShowWarningIcon(false);
    }
  }, [warningInfo, initWarning]);
  (0, _react.useEffect)(function () {
    if (!isSideNavBarInfoOpen) {
      rectClick("reset");
      setShowWarningMessage(false);
    }
  }, [isSideNavBarInfoOpen]);
  return /*#__PURE__*/_react.default.createElement(_reactKonva.Group, null, !isSelected && showWarningIcon ? /*#__PURE__*/_react.default.createElement(_reactKonva.Group, null, /*#__PURE__*/_react.default.createElement(_reactKonva.Image, {
    image: image,
    x: rectProps.x,
    y: rectProps.y - 15,
    width: 10,
    height: 10,
    onMouseOver: function onMouseOver() {
      setShowWarningMessage(true);
    },
    onMouseLeave: function onMouseLeave() {
      setShowWarningMessage(false);
    },
    onClick: tooltipClick,
    style: "cursor:pointer;"
  }), showWarningMessage ? /*#__PURE__*/_react.default.createElement(_reactKonva.Text, {
    text: warningMessage,
    x: rectProps.x + 10,
    y: rectProps.y - (15 + 6 * (warningMessage.split("\n").length - 1))
  }) : null) : null, /*#__PURE__*/_react.default.createElement(_reactKonva.Rect, _extends({
    opacity: isSelected ? 0.35 : 0.2,
    fill: showWarningColour ? "#ffc107" : "#198038",
    strokeScaleEnabled: false,
    onClick: onRectClick,
    ref: rectRef
  }, rectProps, {
    draggable: isSelected,
    onDragMove: function onDragMove(e) {
      updateRectProps(e);

      if (moveAllLinesMode) {
        updateMovingLines(e);
      } else {
        updateStationaryLines(e);
      }
    },
    onDragEnd: onChangeRectEnd,
    onTransform: function onTransform(e) {
      unScaleRectangle();
      updateLineDistance(e);
    },
    onTransformEnd: onChangeTransformEnd
  })));
};

var _default = Rectangle;
exports.default = _default;